import ReactLoadingOverlay, {
  ReactLoadingOverlayProps,
} from 'react-loading-overlay-ts'

type Props = Omit<ReactLoadingOverlayProps, 'spinner'> & {
  children?: React.ReactNode
}

export const LoadingOverlay: React.FC<Props> = (props) => {
  return (
    <ReactLoadingOverlay
      {...props}
      spinner
      fadeSpeed={100}
      styles={{
        spinner: (base: any) => ({
          ...base,
          width: '100px',
          '& svg circle': {
            stroke: 'rgba(210, 214, 219, 0.5)',
          },
        }),
        ...props.styles,
      }}
    />
  )
}
